module.exports = __webpack_public_path__ + "img/FramedBot.91d7ce50.png";